export { TextHighlight } from './TextHighlight';